module.exports = __webpack_public_path__ + "img/wechat1.584c5a63.png";